import React from 'react';
import SurfParagraphList from './SurfParagraphList';
import webapi from '../../../api/webapi';
import EmptyDiv from '../Footer/EmptyDIV';
import Loading from '../modal/Loading';

class SurfParagraphSelectBar extends React.Component{
    
    state = { item: '' };
    state = { modalshow: false };

    componentDidMount() {
        this.setState({ item : '' });   
    }

    async GetData() {
        this.setState({LoadingShow:true})
        await webapi.get('surf/paragraph/'+this.props.SelectedBook+'/'+this.props.SelectedChapter+'/'+this.state.item)
            .then(response => {
                this.setState({ ParagraphList : response.data },()=>{});
            }) 
        this.setState({LoadingShow:false})
    }

    async UpdateParagraphSequenceList(){
        this.setState({LoadingShow:true})
        this.setState({ ParagraphList : '' })
        await webapi.get('surf/chaptersparagraph/'+this.state.SelectedChapter)
            .then(response => {
                this.setState({ ParagraphSequenceList: response.data},()=>{});
            })
        if  (this.state.ParagraphSequenceList.length===1)
        {   
            this.setState({ item : this.state.ParagraphSequenceList[0].Code })
        }
        else
            if  (this.state.ParagraphSequenceList.length>1)
            {
                this.setState({ item : 'All' })
            }
            this.setState({LoadingShow:false})
    }

    componentDidUpdate() {
        if ((this.props.SelectedBook)&&(this.props.SelectedChapter)&&(this.props.SelectedChapter!==this.state.SelectedChapter))
        {
            this.setState({ SelectedBook : this.props.SelectedBook },()=>{});
            this.setState({ SelectedChapter : this.props.SelectedChapter },()=>{this.UpdateParagraphSequenceList();});
        }
     }
     
    onSearchButtonClick = event =>{
        event.preventDefault();
        this.setState({ ParagraphList : '' })
        this.GetData(); 
    }

    onTextChange = event=> {
        this.setState({ item : event.target.value });
        this.setState({ ParagraphList : '' })
    }

    onTextKeyPress = event => {
        if ((event.nativeEvent.key === "Enter")&&(this.state.Item)) {
            event.preventDefault();
            this.onSearchButtonClick(event);
        }
    }
    render(){
        return (
            [
                <div className="SearchBar" style={{margin:'0px auto 0px auto',width:'100%'}}>
                    <form>
                        <div className="divSearch">
                            <div className="fullwidth_div">
                                <label style={{width:'calc(50% - 30px)',margin:'0px',marginRight: '25%',marginTop: '15px', float: 'right'}}>{this.props.Label}</label>
                                <select style={{width:'calc(50% - 30px)',direction:'inherit',margin:'0px 15px',marginRight: '25%',marginTop: '15px', float: 'right'}}
                                    id="item" 
                                    type="text" 
                                    className=""
                                    required="required" 
                                    value={this.state.item || ''} 
                                    onChange={this.onTextChange}
                                    onKeyPress={this.onTextKeyPress}
                                >  
                                    {   
                                        ((this.state.ParagraphSequenceList)&&(this.state.ParagraphSequenceList != null))
                                        ?
                                        (this.state.ParagraphSequenceList.map((ParagraphSequence,i) =>
                                            {
                                                return  (
                                                    (i===0)
                                                    ?
                                                    (
                                                        [
                                                            <option key={ParagraphSequence.Code+"-1"} value={"All"} select="true">{this.props.pageData.length!==0 && this.props.pageData[0].F29902!== undefined?this.props.pageData[0].F29902:29902/*همه*/}</option>
                                                            ,
                                                            <option key={ParagraphSequence.Code} value={ParagraphSequence.Code}>{ParagraphSequence.Title}</option> 
                                                        ]
                                                    )
                                                    :
                                                    (
                                                        <option key={ParagraphSequence.Code} value={ParagraphSequence.Code}>{ParagraphSequence.Title}</option> 
                                                    )
                                                )
                                            })
                                        )
                                        :
                                        <option value="-1">-</option>       
                                    }                
                                </select>
                            </div>
                            
                            <input className="submit_button" type="submit" value={this.props.pageData.length!==0 && this.props.pageData[0].F29901!== undefined?this.props.pageData[0].F29901:29901/*"جستجو"*/} onClick={this.onSearchButtonClick} />
                        </div>
                    </form>
                </div>
                ,
                (this.state.ParagraphList && this.state.ParagraphList.length>0)
                ?
                <SurfParagraphList  ParagraphList={this.state.ParagraphList}
                                    pageData={this.props.pageData}
                />
                :
                <EmptyDiv />
                ,
                <Loading LoadingShow={this.state.LoadingShow} />
            ]
        );
    }
}

export default SurfParagraphSelectBar;